import { FC } from 'react';
import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';

import { ProductCompatibleBatteries } from '@phoenix/team-m/dashboard/frontend/util/product/product-batteries.model';
import { ProductDetails } from '@phoenix/team-m/dashboard/frontend/shared/components/product-details';

import { BatteryPromotion } from './battery-promotion';

interface CompatibleBatteriesCardProps {
  product: ProductCompatibleBatteries;
  className?: string;
}

export const CompatibleBatteriesCard: FC<CompatibleBatteriesCardProps> = ({ product, className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx('grid border border-secondary-mid bg-primary-white desktop:grid-cols-3', className)}
      data-testid={`compatible-batteries-card-${product.articleNumber}`}
    >
      <span className="m-3 ml-4 stihl-text-body-sm-bold desktop:hidden">{t('dashboard_batteries_teaser_table_label_yourProduct')}</span>
      <div className="col-span-1 border-secondary-mid desktop:border-r">
        <ProductDetails imageSrc={product.imageUrl} productName={product.productName} productCategory={product.category} />
      </div>
      <span className="m-3 stihl-text-body-sm-bold desktop:hidden">{t('dashboard_batteries_teaser_table_label_compatibleBatteries')}</span>
      <div className="divide-y divide-secondary-mid desktop:col-span-2">
        {product.compatibleBatteries.map((battery) => (
          <BatteryPromotion battery={battery} key={battery.materialNumber} />
        ))}
      </div>
    </div>
  );
};
